import { render } from "./EwgTab.vue?vue&type=template&id=7d403794&scoped=true"
import script from "./EwgTab.vue?vue&type=script&lang=ts"
export * from "./EwgTab.vue?vue&type=script&lang=ts"

import "./EwgTab.vue?vue&type=style&index=0&id=7d403794&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d403794"

export default script